import { render, staticRenderFns } from "./VincularEscolas.vue?vue&type=template&id=3f3a802c&scoped=true&"
import script from "./VincularEscolas.vue?vue&type=script&lang=js&"
export * from "./VincularEscolas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3a802c",
  null
  
)

export default component.exports